export default {
  metadata: {
    version: '1.0.1',
    id: 'test-1.0.1',
    name: 'TestComponent'
  },
  hierarchy: {
    container: ['heading-text', 'icon', 'image']
  },
  base: {
    container: {
      'padding-top': '50',
      'padding-right': '50',
      'padding-bottom': '50',
      'padding-left': '50',
      'background-color': 'blue',
      'border-color': '',
      'border-radius': '',
      'border-width': '',
      'border-style': '',
      height: '',
      width: '',
      'max-height': '',
      'min-height': '',
      'max-width': '',
      'min-width': '',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      },
      opacity: '',
      'align-items': '',
      'justify-content': '',
      'flex-direction': '',
      gap: '',
      display: '',
      outline: '',
      'pointer-events': '',
      cursor: '',
      'z-index': ''
    },
    'heading-text': {
      color: '#f4f4f4',
      'align-items': '',
      'flex-direction': '',
      'font-family': '',
      'font-size': '',
      'font-weight': '',
      gap: '',
      'justify-content': '',
      'letter-spacing': '',
      'line-height': '',
      opacity: '',
      outline: '',
      'padding-top': 50,
      'padding-right': 50,
      'padding-bottom': 50,
      'padding-left': 50,
      'pointer-events': '',
      width: '',
      'z-index': '',
      'text-decoration': '',
      'text-overflow': '',
      'text-transform': ''
    },
    icon: {
      'background-color': '',
      color: '',
      'padding-top': 50,
      'padding-right': 50,
      'padding-bottom': 50,
      'padding-left': 50,
      height: '24',
      width: '24',
      size: '{m}',
      opacity: '',
      outline: '',
      'justify-content': '',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      },
      'align-items': '',
      'box-sizing': ''
    },
    image: {
      'align-items': '',
      'aspect-ratio': '{aspect_ratio.1.1}',
      'border-radius': '',
      opacity: '',
      hidden: true,
      'padding-top': '50',
      'padding-right': '50',
      'padding-bottom': '50',
      'padding-left': '50',
      'pointer-events': '',
      'box-shadow': {
        x: 0,
        y: 4,
        blur: 16,
        spread: 0,
        color: '#00000014'
      },
      'object-fit': '',
      'object-position': ''
    }
  },
  variant: {
    kind: {
      SERVICE: {
        container: {
          'border-radius': '{pill}',
          'background-color': '#75757580',
          'padding-top': '{xxs}',
          'padding-left': '{xxs}',
          'padding-right': '{s}',
          'padding-bottom': '{xxs}',
          gap: '{xs}'
        },
        'heading-text': {
          appearance: 'BODY_M_BOLD',
          color: 'WHITE'
        },
        icon: {
          size: '{m}',
          color: '{global.transparent}'
        }
      }
    }
  },
  api: {
    data: {
      'heading-text': {
        value: {
          type: 'string',
          name: 'label'
        }
      },
      icon: {
        value: {
          type: 'icon',
          name: 'icon'
        }
      },
      image: {
        value: {
          type: 'image',
          name: 'image'
        }
      }
    },
    config: {
      kind: {
        values: ['NORMAL', 'SERVICE']
      }
    }
  }
};
